import groq from 'groq';
import { ComponentType } from '$lib/sanity/types';
import { RichTextFragment } from './text';

export const QuoteComponentFragment = groq`
...,
copy[] {
  ${RichTextFragment}
},
authorInfo {
  ...,
  name[] {
    ${RichTextFragment}
  },
  title[] {
    ${RichTextFragment}
  }
}
`;

export const GetQuoteComponent = groq`
*[_type == "${ComponentType.Quote}" && _id == $id]{
  ${QuoteComponentFragment}
}[0]
`;
